import { Component, Host, Prop, State, h } from '@stencil/core';

@Component({
  tag: 'cradlepoint-container',
  styleUrl: 'cradlepoint-container.css',
  shadow: true,
})
export class CradlepointContainer {
  @Prop() maxWidth: string = '1350px';
  @Prop() columns : string = '1fr';
  @Prop() gap : string = '0';
  @Prop() gapColumn: string = null;
  @Prop() gapRow: string = null;
  @Prop() backgroundColor: string = null;
  @Prop() mdColumns: string = null;

  @State() containerStyle: object = {
    maxWidth: this.maxWidth,
    columnGap: (this.gapColumn ? this.gapColumn : this.gap),
    rowGap: (this.gapRow ? this.gapRow : this.gap),
    backgroundColor: this.backgroundColor && this.backgroundColor
  };

  desktopStyle = null;

  componentWillRender() {
    this.columns && (this.desktopStyle = `
      @media (min-width:768px) and (max-width:1023px){
        :host {
          grid-template-columns: ${ this.mdColumns };
        }
      }
      @media (min-width:1024px) {
        :host {
          grid-template-columns: ${this.columns};
        }
      }
    `)
  }

  render() {
    return (
      <Host
        style={{
          maxWidth: this.maxWidth,
          columnGap: (this.gapColumn ? this.gapColumn : this.gap),
          rowGap: (this.gapRow ? this.gapRow : this.gap),
          backgroundColor: this.backgroundColor
        }}
      >
        {this.desktopStyle && <style scoped>{this.desktopStyle}</style>}
        <slot></slot>
      </Host>
    );
  }

}
